import { useTranslation } from 'react-i18next'

import { Checkbox, ComboBox, Text } from '@reveni-io/reveni-ui'

import {
  actionTypeOptions,
  actionTypeValues,
  bonusOptions,
  transactionTypes as constantsTransactionTypes,
} from './constants'
import * as Styles from './styles'

const ActionsSection = ({
  actionForTransactionTypes,
  onChangeActionForTransactionTypes,
  setUseCustomMessage,
  action,
  onChangeAction,
  bonusTypes,
  onChangeBonusTypes,
}) => {
  const { t } = useTranslation()

  const handleChangeActionForTransactionTypes = (value, checked) => {
    if (checked) {
      onChangeActionForTransactionTypes([...actionForTransactionTypes, value])
      if (action === actionTypeValues.block) setUseCustomMessage(true)
    } else {
      onChangeActionForTransactionTypes(actionForTransactionTypes.filter(type => type !== value))
    }
  }

  const handleChangeBonusTypes = (value, checked) => {
    if (checked) {
      onChangeBonusTypes([...bonusTypes, value])
    } else {
      onChangeBonusTypes(bonusTypes.filter(type => type !== value))
    }
  }

  return (
    <Styles.Container>
      <Text type="titleS">{t('Acciones')}</Text>
      <Text type="bodyMRegular">{t('Define que acción se ejecutará al seleccionar este motivo en el portal')}:</Text>
      <ComboBox
        label="Tipo de acción"
        handleChange={e => onChangeAction(e.target.value)}
        menuItems={actionTypeOptions.map(o => ({ ...o, label: t(o.label) }))}
        value={action}
      />
      {[actionTypeValues.block, actionTypeValues.onHold].includes(action) && (
        <Styles.BlockContainer>
          <Text type="bodyMRegular">
            {action === actionTypeValues.onHold
              ? t('Poner en estado “En espera” y requerir preaprobación para tramitar las solicitudes de')
              : t('Bloquear para ese producto las solicitudes de')}
            :
          </Text>
          <Styles.CheckboxesContainer>
            {constantsTransactionTypes.map((transactionType, index) => (
              <Checkbox
                key={index}
                label={t(transactionType.label)}
                checked={actionForTransactionTypes.includes(transactionType.value)}
                onChange={e => handleChangeActionForTransactionTypes(transactionType.value, e.target.checked)}
              />
            ))}
          </Styles.CheckboxesContainer>
        </Styles.BlockContainer>
      )}
      {action === actionTypeValues.bonus && (
        <Styles.BlockContainer>
          <Text type="bodyMRegular">{t('Aplicar bonificaciones a la solicitud')}:</Text>
          <Styles.CheckboxesContainer>
            {bonusOptions.map((bonus, index) => (
              <Checkbox
                key={index}
                label={t(bonus.label)}
                checked={bonusTypes.includes(bonus.value)}
                onChange={e => handleChangeBonusTypes(bonus.value, e.target.checked)}
              />
            ))}
          </Styles.CheckboxesContainer>
        </Styles.BlockContainer>
      )}
    </Styles.Container>
  )
}

export default ActionsSection
